import {PlaceTypeEnumType} from '@wix/ambassador-seating-v1-seating-reservation/types'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isPlaceReservableAsWhole, isPlaceSeatTypeImage} from '../../../../../../selectors/seating/place'
import {getSeatTypeTitle} from '../../../utils'
import {SeatInfoProps} from './interfaces'
import {SeatInfoIcon} from './seat-info-icon'
import {classes} from './seat-info.st.css'

const SEAT_INFO_ICON_LIMIT = 6

const SeatInfoIconContainer = ({type}: {type: PlaceTypeEnumType}) => {
  const {t} = useTranslation()
  const title = getSeatTypeTitle(type, t)

  return (
    <div className={classes.seatIconContainer}>
      <SeatInfoIcon type={type} />
      <Text className={classes.description}>{title}</Text>
    </div>
  )
}

const SeatInfoContent = ({place, inDescription}: SeatInfoProps) => {
  const {t} = useTranslation()

  const wholeTable = isPlaceReservableAsWhole(place)

  if (wholeTable) {
    const {places} = place
    const placesWithSeatTypes = places.filter(isPlaceSeatTypeImage)

    if (inDescription) {
      return (
        <div className={classes.seatLabelListContainer}>
          {placesWithSeatTypes.map(({type, label}, i) => (
            <div key={i} className={classes.seatLabelContainer}>
              <Text className={classes.seatLabel}>{t('seatings_seatInfo_table_seatLabel', {label})}</Text>
              <SeatInfoIconContainer type={type} />
            </div>
          ))}
        </div>
      )
    }

    const types = placesWithSeatTypes.map(({type}) => type)
    const typesLimitReached = types.length > SEAT_INFO_ICON_LIMIT
    const typesOverflowCount = types.length - SEAT_INFO_ICON_LIMIT

    return (
      <>
        <div className={classes.seatIcons}>
          {types.slice(0, SEAT_INFO_ICON_LIMIT).map((type, i) => (
            <SeatInfoIcon key={i} type={type} />
          ))}
          <Text className={classes.additionalInfo}>
            {typesLimitReached ? t('seatings_seatInfo_limitReached_text', {count: typesOverflowCount}) : ''}
          </Text>
        </div>
        <Text className={classes.additionalInfo}>{t('seatings_seatInfo_table_additionalInfo')}</Text>
      </>
    )
  }

  return <SeatInfoIconContainer type={place.type} />
}

export const SeatInfo = ({place, inDescription}: SeatInfoProps) => {
  const {t} = useTranslation()

  return (
    <div className={classes.seatInfoContainer}>
      <Text className={classes.smallText}>{t('seatings_seatInfo_title')}</Text>
      <SeatInfoContent place={place} inDescription={inDescription} />
    </div>
  )
}
